(function ($) {

    $('body').on('click', '.nav-social-trigger', toggleClass);
    $('body').on('click', '.channel>.icon', toggleChannel);

    // Accessibilty Issue 1.40 Social button is implemented incorrectly from SC team
    $(".nav-social-trigger").on('click', function () {
        if ($(this).closest('.nav-social').hasClass('nav-social-on')) {
            $(this).attr("aria-expanded", 'false');
        }
        else {
            $(this).attr("aria-expanded", 'true');
        }
    });
    $(".nav-social-trigger").on('keypress', function (e) {
        if (e.which === 13) {
            if ($(this).closest('.nav-social').hasClass('nav-social-on')) {
                $(this).attr("aria-expanded", 'false');
            }
            else {
                $(this).attr("aria-expanded", 'true');
            }
        }
    });
    $('.nav-social-trigger').keydown(function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '27') {
            if ($(this).closest('.nav-social').hasClass('nav-social-on')) {
                $(this).attr("aria-expanded", 'false');
                $(this).closest('.nav-social').toggleClass('nav-social-on');
            }
        }
    });
    $('.nav-social-icons').keydown(function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '27') {
            if ($(this).closest('.nav-social').hasClass('nav-social-on')) {
                $('#socialDropdown').attr("aria-expanded", 'false');
                $(this).closest('.nav-social').toggleClass('nav-social-on');
                $('#socialDropdown').focus();

            }
        }
    });

    function toggleClass() {
        $(this).closest('.nav-social').toggleClass('nav-social-on');
    }

    function toggleChannel() {
        if ($(this).closest('.channel').hasClass('channel-open')) {
            $('.channel').removeClass('channel-open');
        } else {
            $('.channel').removeClass('channel-open');
            $(this).closest('.channel').addClass('channel-open');
        }

    }
    // chemical social share 
    $(".social-share-content .social-share-item .linkedin").unbind();
    $(document).on("click", ".social-share-content .social-share-item .linkedin", function () {
        $(document).on("click", ".social-share-content .social-share-item .linkedin button", function (e) {
            e.stopPropagation();
        });
        $(".linkedin").find("button").click();
    });

    $(document).on("click", ".social-share-content .social-share-item .twitter", function () {
        var ogUrl = $('[property="og:url"]').attr("content").replace(/\s/g, "-");
        var ogTitle = $('[property="og:title"]').attr("content");
        var encodeText = encodeURI(ogTitle);
        window.open("https://www.twitter.com/intent/tweet?text=" + encodeText + "&url=" + ogUrl);
    });


}(window.jQuery));

analytics.eventConfig.push({
    "target": "ul.nav-social-icons",
    "codeId": "si",
    "events": [
        {
            "eventTarget": "a:not([href^=\\#],[href*=\\http])",
            "eventType": "click",
            "tags": {
                "componentId": "si",
                "componentName": "social icon",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "social icon",
                "event": [

                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "contact"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "navigation"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().startsWith('mailto:')",
                        "value": "click to email"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').search(new RegExp('pdf|xls|xlsx|doc|docx', 'i')) > -1",
                        "value": "other media asset click"
                    },
                    {
                        "rule": "true",
                        "value": "social icon internal navigation click"
                    }
                ],
                "parentName": "",
                "fileName": ""
            }
        },
        {
            "eventTarget": "a[href*=\\http]",
            "eventType": "click",
            "tags": {
                "componentId": "si",
                "componentName": "social icon",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "social icon",
                "event": [
                    {
                        "rule": "$(context).attr('href') && ($(context).attr('href').toLowerCase().search('pds') !== -1 || $(context).attr('href').toLowerCase().search('psims') !== -1)",
                        "value": "download"
                    },
                    {
                        "rule": "true",
                        "value": "outbound"
                    }
                ],
                "eventType": [
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('pds') !== -1 ",
                        "value": "pds download click"
                    },
                    {
                        "rule": "$(context).attr('href') && $(context).attr('href').toLowerCase().search('psims') !== -1",
                        "value": "sds download click"
                    },
                    {
                        "rule": "true",
                        "value": "social icon outbound click"
                    }
                ],
                "parentName": "",
                "fileName": ""
            }
        }
    ]
});
